import chrismasIcon from "@/assets/icons/snow.svg";
import peachFlowerIcon from "@/assets/icons/peach-flower.svg";
import profileIcon from "@/assets/icons/user-profile.svg";
import postcardIcon from "@/assets/icons/postcard.svg";
import quoteOfTheDayIcon from "@/assets/icons/quote.svg";
import petIcon from "@/assets/icons/pet.svg";
import websiteIcon from "@/assets/icons/website.svg";
import type { ITemplateType } from "@/store/interface/template";

interface ITemplate {
  key: ITemplateType;
  name: string;
  description: string;
  icon: string;
}

export const templates: ITemplate[] = [
  {
    key: "christmas",
    name: "Christmas",
    description: "Trang nội dung dành cho thông điệp Tết.",
    icon: chrismasIcon,
  },
    {
    key: "tet",
    name: "Thiệp chúc Tết",
    description: "Trang nội dung dành cho thông điệp Tết.",
    icon: peachFlowerIcon,
  },
  {
    key: "profile",
    name: "Profile",
    description: "Tạo trang cá nhân chuyên nghiệp của bạn.",
    icon: profileIcon,
  },
  {
    key: "postcard",
    name: "Post card",
    description: "Bưu thiếp đa phương tiện, cá nhân hóa.",
    icon: postcardIcon,
  },
  {
    key: "quote_of_the_day",
    name: "Quote of the day",
    description: "Mỗi ngày một thông điệp, một lời nhắn.",
    icon: quoteOfTheDayIcon,
  },
  {
    key: "pet",
    name: "Pet",
    description: "Trang nội dung dành cho thú cưng của bạn.",
    icon: petIcon,
  },
  {
    key: "website",
    name: "Website",
    description: "Nhập đường dẫn tời trang nội dung của bạn.",
    icon: websiteIcon,
  },
];

export const CHIP_STATUS = {
  UNASSIGNED: "unassigned",
  ASSIGNED: "assigned",
  READY: "ready",
  ACTIVATED: "activated",
  LOCKED: "locked",
  DISABLED: "disabled",
};

export const CHIP_ACTIVATED_STATUS = {
  READY: "ready",
  ACTIVATED: "activated",
};

export const CHIP_ERROR_STATUS = {
  UNASSIGNED: "unassigned",
  ASSIGNED: "assigned",
};
